import { Grid } from '@mui/material';
import { useMemo, useState } from 'react';
import { CodPositions } from 'src/constants';
import { OrderStates } from 'src/constants/assemblyJourneys';
import { GlobalComponentsInterface } from 'src/interfaces';
import { lang } from 'src/utils';

import { GlobalComponentCardList } from './GlobalComponentCardList';
import { ScreenConfigButtonGroup } from './ScreenConfigButtonGroup';
import { getScreenOptions } from './ScreenConfigSection.helper';
import {
  IChannelType,
  IHandleGlobalComponentsScreensChange,
} from './ScreenConfigSection.interface';
import { ScreenConfigSelect } from './ScreenConfigSelect';
import { ScreenThumbnails } from './ScreenThumbnails';

export const ChannelTabPanel = ({
  channelType,
  selectedTab,
  globalComponents,
  codPosition,
  handleChange,
}: {
  channelType: IChannelType;
  selectedTab: string;
  globalComponents: GlobalComponentsInterface[];
  codPosition: CodPositions;
} & IHandleGlobalComponentsScreensChange) => {
  const [screenLayoutType, setScreenLayoutType] = useState(
    channelType.screenLayouts?.[0].layoutType,
  );
  const [selectedState, setSelectedState] = useState(OrderStates[0]);

  const channelOptions = channelType.screenLayouts.map((item) => ({
    label: item.layoutType,
    value: item.layoutType,
  }));
  const screenOptions = useMemo(
    () =>
      getScreenOptions(channelType.screenNumber, codPosition, screenLayoutType),
    [channelType.screenNumber, codPosition, screenLayoutType],
  );

  const screenLayout =
    channelType.screenLayouts.find(
      (layout) => layout.layoutType === screenLayoutType,
    ) || channelType.screenLayouts[0];

  return (
    <Grid
      container
      height={350}
      sx={{ display: channelType.label === selectedTab ? 'flex' : 'none' }}>
      <Grid item minWidth={508} width={508}>
        <ScreenConfigButtonGroup
          selectedState={selectedState}
          setSelectedState={setSelectedState}
          orderStates={OrderStates}
        />

        {channelType.screenNumber === 2 && (
          <Grid item marginBottom={2}>
            <ScreenConfigSelect
              label={lang.customerTriggeredEventsPage.screenLayoutType}
              width="350px"
              value={screenLayoutType}
              onChange={(value) => setScreenLayoutType(value as string)}
              options={channelOptions}
            />
          </Grid>
        )}

        <GlobalComponentCardList
          channelType={channelType}
          screenLayout={screenLayout}
          screenOptions={
            codPosition === CodPositions.LEFT
              ? screenOptions
              : [...screenOptions].reverse()
          }
          globalComponents={globalComponents}
          selectedState={selectedState}
          handleChange={handleChange}
        />
      </Grid>

      <Grid item xs marginLeft={5}>
        <ScreenThumbnails
          screenLayout={screenLayout}
          screenOptions={screenOptions}
          selectedState={selectedState}
          codPosition={codPosition}
        />
      </Grid>
    </Grid>
  );
};
